import { Component, OnInit } from '@angular/core';
import { IMangeQuoteLbl } from '../../../core/models';
import { LanguageTranslationService } from '../../../core/services/language-translation.service';

@Component({
  selector: 'app-manage-quote',
  templateUrl: './manage-quote.component.html',
  styleUrls: ['./manage-quote.component.scss']
})
export class ManageQuoteComponent implements OnInit {
  manageQuoteTxt: IMangeQuoteLbl;

  constructor(private languageTranslationService: LanguageTranslationService) { }

  ngOnInit() {
    this.loadLanguageTranslationData();
  }
  //#region Language translate
  loadLanguageTranslationData() {
    const controlNameList = [
      { controlName: "KDQuoteHeadingLbl" },
      { controlName: "KDQuoteLbl1" },
      { controlName: "inHouseHeadingLbl" },
      { controlName: "inHouseLbl1" },
      { controlName: "requestQuoteHeadingLbl" },
      { controlName: "requestQuoteLbl1" },
      { controlName: "factoryQuoteHeadingLbl" },
      { controlName: "factoryQuoteLbl1" },

    ];
    const componentName = "manageQuote";
    const response = this.languageTranslationService.getLanguageTranslationList(controlNameList, componentName);
    if (response.length > 0) {
      this.manageQuoteTxt = response[response.length - 1];
      console.log(response);
    }
  }
  //#endregion
  //#region label declaration
  public manageQuote = {
    KDQuoteHeadingLbl: "KawneerDirect Quotes",
    KDQuoteLbl1: "Manage quotes you create on KawneerDirect",
    inHouseHeadingLbl: "In-House Quote",
    inHouseLbl1: "Manage quotes requested from our in-house estimating resources",
    requestQuoteHeadingLbl: "Request a Quote",
    requestQuoteLbl1: "Request a quote from our in-house estimating resources",
    factoryQuoteHeadingLbl: "Factory Quote Request",
    factoryQuoteLbl1: "Fill out a factory quote request form  for windows and GLASSvents",
  }
  //#endregion
}
